import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GraficoHome } from '../models/grafico-home';
import { ResponseBase } from '../models/response-base';

@Injectable({
  providedIn: 'root'
})
export class GraficoHomeService {

  private URL = environment.GATEWAY;

  constructor(private http: HttpClient) { }

  getDashboardOrders(cedenteGuid: string) {

    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.get<ResponseBase<GraficoHome[]>>(`${this.URL}dashboard/orders/${cedenteGuid}`, { headers });
  }
}
